// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.finance {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.finance__filters-types {
  display: flex;
}
.finance__filters-row {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
}
.finance__filters-field {
  min-width: 200px;
  flex-shrink: 0;
}
.finance__filters-type--active {
  opacity: 1;
}
.finance__filters-type--active button,
.finance__filters-type--active a {
  background: #f4f4f4;
}
.finance__filters-type--active button span,
.finance__filters-type--active a span {
  color: #131313;
}
.finance__create {
  padding: 16px;
  background: rgba(20, 21, 23, 0.9);
  border-radius: 8px;
}
.finance__title {
  color: #ffffff;
  margin-bottom: 12px;
  font-size: 18px;
}
.finance__pagination {
  margin-top: 16px;
}

.finance-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  /* TRANSFER: ID, Название, RUB, Сумма перевода, Сумма закупки,
     Валюта, Прибыль, Тип, Описание, Город, Дата, Автор, Действия */
  /* SALARY: ID, Имя, Сумма, Тип, Описание, Дата, Автор, Действия */
  /* EXPENSES: ID, Название, Сумма, Тип, Город, Описание, Дата, Автор, Действия */
  /* 1200–1500 и мобилки: карточный вид с подписями */
}
.finance-table__header, .finance-table__row {
  display: grid;
  column-gap: 4px;
  padding: 7px 26px;
  align-items: center;
  border-radius: 20px;
  margin-bottom: 10px;
}
.finance-table__header {
  background: rgba(35, 38, 43, 0.95);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.3px;
  color: #a9adb3;
}
.finance-table__body {
  display: flex;
  flex-direction: column;
}
.finance-table__body .finance-table__cell {
  font-size: 18px;
}
.finance-table__row {
  font-size: 14px;
  color: #f4f4f4;
  border: 1px solid rgba(70, 74, 81, 0.7);
  align-items: center;
  background: rgba(35, 38, 43, 0.95);
  border-radius: 20px;
}
.finance-table__header--transfer, .finance-table__row--transfer {
  grid-template-columns: 40px repeat(10, 1fr);
}
.finance-table__header--salary, .finance-table__row--salary {
  grid-template-columns: repeat(7, 1fr);
}
.finance-table__header--expenses, .finance-table__row--expenses {
  grid-template-columns: repeat(8, 1fr);
}
.finance-table__cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.finance-table__cell--id {
  font-weight: 500;
}
.finance-table__cell--user {
  font-size: 13px;
}
.finance-table__cell--date {
  font-size: 13px;
  opacity: 0.8;
}
.finance-table__cell--actions {
  flex-shrink: 0;
  min-width: 250px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}
.finance-table__delete {
  opacity: 0.85;
}
.finance-table__accordion {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  opacity: 0;
  padding: 0 16px;
  background: rgba(18, 19, 22, 0.9);
}
.finance-table__accordion-inner {
  padding-top: 12px;
  padding-bottom: 12px;
}
.finance-table__accordion--open {
  max-height: 500px;
  opacity: 1;
  padding: 0 16px 12px;
  overflow: unset;
}
.finance-table__empty {
  padding: 16px;
  text-align: center;
  color: #a9adb3;
}
@media (max-width: 1700px) and (min-width: 601px), (max-width: 1024px) {
  .finance-table__header {
    display: none;
  }
  .finance-table__row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 4px;
    column-gap: 8px;
    padding: 12px 16px;
  }
  .finance-table__cell {
    white-space: normal;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .finance-table__cell[data-label]::before {
    content: attr(data-label) ":";
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.7;
    flex-shrink: 0;
  }
  .finance-table__cell--actions::before {
    content: "";
    display: none;
  }
  .finance-table__cell--actions {
    grid-column: 1/-1;
    justify-content: flex-start;
    margin-top: 6px;
  }
}
@media (max-width: 600px) {
  .finance-table__row {
    grid-template-columns: minmax(0, 1fr);
  }
  .finance-table__cell--actions {
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/FinanceList/FinanceList.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEF;AACI;EACE,aAAA;AACN;AAEI;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;AAAN;AAGI;EACE,gBAAA;EACA,cAAA;AADN;AAKM;EACE,UAAA;AAHR;AAIQ;;EAEE,mBAAA;AAFV;AAGU;;EACE,cAAA;AAAZ;AAOE;EACE,aAAA;EACA,iCAAA;EACA,kBAAA;AALJ;AAQE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AANJ;AASE;EACE,gBAAA;AAPJ;;AAWA;EAEE,WAAA;EACA,kBAAA;EACA,gBAAA;EA4CA;mEAAA;EAOA,iEAAA;EAMA,+EAAA;EAgEA,mDAAA;AA7HF;AAOE;EAEE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,kCAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AARJ;AAWE;EACE,aAAA;EACA,sBAAA;AATJ;AAWI;EACE,eAAA;AATN;AAgBE;EACE,eAAA;EACA,cAAA;EACA,uCAAA;EAEA,mBAAA;EACA,kCAAA;EACA,mBAAA;AAfJ;AAoBE;EAEE,2CAAA;AAnBJ;AAuBE;EAEE,qCAAA;AAtBJ;AA0BE;EAEE,qCAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1BJ;AA2BI;EACE,gBAAA;AAzBN;AA4BI;EACE,eAAA;AA1BN;AA6BI;EACE,eAAA;EACA,YAAA;AA3BN;AA8BI;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AA5BN;AAgCE;EACE,aAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,gBAAA;EACA,sEAAA;EACA,UAAA;EACA,eAAA;EACA,iCAAA;AA/BJ;AAkCE;EACE,iBAAA;EACA,oBAAA;AAhCJ;AAmCE;EACE,iBAAA;EACA,UAAA;EACA,oBAAA;EACA,eAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AAlCJ;AAsCE;EAEE;IACE,aAAA;EArCJ;EAwCE;IACE,aAAA;IACA,gDAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EAtCJ;EAyCE;IACE,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;EAvCJ;EA0CE;IACE,6BAAA;IACA,eAAA;IACA,yBAAA;IACA,sBAAA;IACA,YAAA;IACA,cAAA;EAxCJ;EA2CE;IACE,WAAA;IACA,aAAA;EAzCJ;EA4CE;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EA1CJ;AACF;AA6CE;EACE;IACE,qCAAA;EA3CJ;EA8CE;IACE,2BAAA;EA5CJ;AACF","sourcesContent":[".finance {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n\r\n  &__filters {\r\n    &-types {\r\n      display: flex;\r\n    }\r\n\r\n    &-row {\r\n      position: relative;\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      justify-content: flex-start;\r\n      gap: 10px;\r\n      width: 100%;\r\n    }\r\n\r\n    &-field {\r\n      min-width: 200px;\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    &-type {\r\n      &--active {\r\n        opacity: 1;\r\n        button,\r\n        a {\r\n          background: #f4f4f4;\r\n          span {\r\n            color: #131313;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &__create {\r\n    padding: 16px;\r\n    background: rgba(20, 21, 23, 0.9);\r\n    border-radius: 8px;\r\n  }\r\n\r\n  &__title {\r\n    color: #ffffff;\r\n    margin-bottom: 12px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  &__pagination {\r\n    margin-top: 16px;\r\n  }\r\n}\r\n\r\n.finance-table {\r\n  $selfTable: &;\r\n  width: 100%;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  //background: rgba(24, 26, 30, 0.9);\r\n\r\n  &__header,\r\n  &__row {\r\n    display: grid;\r\n    column-gap: 4px;\r\n    padding: 7px 26px;\r\n    align-items: center;\r\n\r\n    border-radius: 20px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  &__header {\r\n    background: rgba(35, 38, 43, 0.95);\r\n    font-size: 12px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1.3px;\r\n    color: #a9adb3;\r\n  }\r\n\r\n  &__body {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    #{$selfTable}__cell{\r\n      font-size: 18px;\r\n    }\r\n  }\r\n\r\n  &__item {\r\n  }\r\n\r\n  &__row {\r\n    font-size: 14px;\r\n    color: #f4f4f4;\r\n    border: 1px solid rgba(70, 74, 81, 0.7);\r\n\r\n    align-items: center;\r\n    background: rgba(35, 38, 43, 0.95);\r\n    border-radius: 20px;\r\n  }\r\n\r\n  /* TRANSFER: ID, Название, RUB, Сумма перевода, Сумма закупки,\r\n     Валюта, Прибыль, Тип, Описание, Город, Дата, Автор, Действия */\r\n  &__header--transfer,\r\n  &__row--transfer {\r\n    grid-template-columns: 40px repeat(10, 1fr);\r\n  }\r\n\r\n  /* SALARY: ID, Имя, Сумма, Тип, Описание, Дата, Автор, Действия */\r\n  &__header--salary,\r\n  &__row--salary {\r\n    grid-template-columns: repeat(7, 1fr);\r\n  }\r\n\r\n  /* EXPENSES: ID, Название, Сумма, Тип, Город, Описание, Дата, Автор, Действия */\r\n  &__header--expenses,\r\n  &__row--expenses {\r\n    grid-template-columns: repeat(8, 1fr);\r\n  }\r\n\r\n  &__cell {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    &--id {\r\n      font-weight: 500;\r\n    }\r\n\r\n    &--user {\r\n      font-size: 13px;\r\n    }\r\n\r\n    &--date {\r\n      font-size: 13px;\r\n      opacity: 0.8;\r\n    }\r\n\r\n    &--actions {\r\n      flex-shrink: 0;\r\n      min-width: 250px;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      justify-content: flex-end;\r\n    }\r\n  }\r\n\r\n  &__delete {\r\n    opacity: 0.85;\r\n  }\r\n\r\n  &__accordion {\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;\r\n    opacity: 0;\r\n    padding: 0 16px;\r\n    background: rgba(18, 19, 22, 0.9);\r\n  }\r\n\r\n  &__accordion-inner {\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n  }\r\n\r\n  &__accordion--open {\r\n    max-height: 500px;\r\n    opacity: 1;\r\n    padding: 0 16px 12px;\r\n    overflow: unset;\r\n  }\r\n\r\n  &__empty {\r\n    padding: 16px;\r\n    text-align: center;\r\n    color: #a9adb3;\r\n  }\r\n\r\n  /* 1200–1500 и мобилки: карточный вид с подписями */\r\n  @media (max-width: 1700px) and (min-width: 601px),\r\n  (max-width: 1024px) {\r\n    &__header {\r\n      display: none;\r\n    }\r\n\r\n    &__row {\r\n      display: grid;\r\n      grid-template-columns: repeat(2, minmax(0, 1fr));\r\n      row-gap: 4px;\r\n      column-gap: 8px;\r\n      padding: 12px 16px;\r\n    }\r\n\r\n    &__cell {\r\n      white-space: normal;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 6px;\r\n    }\r\n\r\n    &__cell[data-label]::before {\r\n      content: attr(data-label) \":\";\r\n      font-size: 12px;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.05em;\r\n      opacity: 0.7;\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    &__cell--actions::before {\r\n      content: \"\";\r\n      display: none;\r\n    }\r\n\r\n    &__cell--actions {\r\n      grid-column: 1 / -1;\r\n      justify-content: flex-start;\r\n      margin-top: 6px;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 600px) {\r\n    &__row {\r\n      grid-template-columns: minmax(0, 1fr);\r\n    }\r\n\r\n    &__cell--actions {\r\n      justify-content: flex-start;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
